module.exports = __webpack_public_path__ + "static/media/result-loop.bd4c930e.wav";